import axios from 'src/config/axios'
import commonApi from 'src/api/common'
import courseware from 'src/api/courseware'
export default {
  // 获取基础信息
  getBasicInfo: ({ commit }) => {
    return axios.get(commonApi.getBasicInfo, {
      params: {getAll: 1}
    }).then(response => {
      commit('SET_BASICINFO', response)
      return response
    })
  },
  getProductionType: ({ commit }) => {
    return axios.get(commonApi.getProductionType).then(response => {
      return response
    })
  },
  getData: ({ commit }, data) => {
    return axios.get(data.src, {
      params: data.params
    }).then(response => {
      return response
    })
  },
  searchPageList: ({ commit }, params) => {
    return axios.get(courseware.searchPageList, {
      params: params
    }).then(response => {
      return response
    })
  },
  previewPage: ({ commit }, params) => {
    return axios.get(courseware.previewPage, {
      params: params
    }).then(response => {
      return response
    })
  },
  // 获取基础信息 用于背景图列表返回所有年级
  getBasicInfoBgList: ({ commit }) => {
    return axios.get(commonApi.getBasicInfo, {
      params: {
        getAll: 1
      }
    }).then(response => {
      commit('SET_BASICINFOBGLIST', response)
      return response
    })
  },
  // 设置课件详情页面包数据
  setPackages: ({ commit }, packages) => {
    commit('SET_PACKAGES', packages)
  },
  // 更新页面包
  updatePackage: ({ commit }, packageInfo) => {
    commit('UPDATE_PACKAGE', packageInfo)
  },
  // 设置课件基础数据
  setCoursewareInfo: ({ commit }, info) => {
    commit('SET_COURSEWARE_INFO', info)
  },
  // 更新一个页面数据
  updatePage: ({ commit }, info) => {
    commit('UPDATE_PAGE', info)
  },
  // 设置、更新列表筛选数据
  setFilterData: ({commit}, data) => {
    commit('SET_FILTER_DATA', data)
  },
  // 清空筛选数据
  clearFilterData: ({commit}) => {
    commit('CLEAR_FILTER_DATA')
  },
  // 筛选背景图数据
  setBackStatus: ({ commit }, backstatus) => {
    commit('SET_BACK_STATUS', backstatus)
  }
}




// WEBPACK FOOTER //
// ./src/store/courseware/actions.js